import { render } from "./WinnersList.vue?vue&type=template&id=33f58812&scoped=true&bindings={}"
import script from "./WinnersList.vue?vue&type=script&lang=ts"
export * from "./WinnersList.vue?vue&type=script&lang=ts"

import "./WinnersList.vue?vue&type=style&index=0&id=33f58812&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-33f58812"

export default script